(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-buy-now"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('floating-buy-jump')) {
  const dailyKey='xiwen_buy_now_click_day_v1';
  let memoryDay='';
  window.addEventListener('click',event=> {
    const link=event.target.closest?.('[data-xiwen-buy-now="floating"]');
    const host=link?.closest('floating-buy-jump');
    if (!host || host.dataset.xiwenDailyLimit !== 'true' || event.button !== 0) return;
    if (!document.getElementById('standard-purchase')) return;
    const today=new Intl.DateTimeFormat('sv-SE',{
      timeZone:host.dataset.xiwenDayTimezone,year:'numeric',month:'2-digit',day:'2-digit'
    }).format(new Date());
    let counted=memoryDay === today;
    try { counted=counted || localStorage.getItem(dailyKey) === today; } catch {}
    if (counted) {
      host.dataset.xiwenClickStatus='already_counted_today';
      event.preventDefault();
      event.stopImmediatePropagation();
      host.jumpToPurchase(event);
      return;
    }
    memoryDay=today;
    try { localStorage.setItem(dailyKey,today); } catch {}
    host.dataset.xiwenClickStatus='first_click_today';
  },{capture:true});
  customElements.define('floating-buy-jump',class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort=new AbortController();
      const sync=()=> {
        this.target=document.getElementById('standard-purchase');
        const themeVisible=this.dataset.themeToggle !== 'false' && [...document.querySelectorAll('sticky-add-to-cart [ref="stickyBar"], sticky-add-to-cart .sticky-add-to-cart__bar')].some(bar=> {
          const style=getComputedStyle(bar);
          if (style.display === 'none' || style.visibility === 'hidden' || bar.hidden) return false;
          const host=bar.closest('sticky-add-to-cart');
          const unavailable=host?.getAttribute('data-variant-available') === 'false';
          const rect=bar.getBoundingClientRect();
          if (!rect.width || !rect.height) return false;
          if (bar.getAttribute('data-stuck') === 'true' && !unavailable) return true;
          return Number(style.opacity)>0.01 && rect.width>0 && rect.height>0 && rect.top<innerHeight && rect.bottom>0;
        });
        const hidden=!this.target || themeVisible;
        const ownBar=this.querySelector('.fbj-bar');
        if (ownBar.hidden !== hidden) ownBar.hidden=hidden;
        this.classList.toggle('fbj-enabled',Boolean(this.target));
      };
      const schedule=()=> {
        if (this.raf) return;
        this.raf=requestAnimationFrame(()=> { this.raf=0; sync(); });
      };
      sync();
      this.observer=new MutationObserver(records=> {
        if (!records.some(record=> !this.contains(record.target))) return;
        schedule();
        clearTimeout(this.settle);
        this.settle=setTimeout(schedule,450);
      });
      this.observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-stuck','data-variant-available','class','style','hidden']});
      const options={passive:true,signal:this.abort.signal};
      window.addEventListener('scroll',schedule,options);
      window.addEventListener('resize',schedule,options);
      document.addEventListener('transitionend',event=> {
        if (event.target.closest?.('sticky-add-to-cart')) schedule();
      },{signal:this.abort.signal});
      this.querySelector('a').addEventListener('click',event=> {
        sync();
        this.jumpToPurchase(event);
      },{signal:this.abort.signal});
    }
    jumpToPurchase(event) {
      this.target=document.getElementById('standard-purchase');
      if (!this.target) return;
      event.preventDefault();
      const offset=Number(this.dataset.offset) || 0;
      const top=Math.max(0,this.target.getBoundingClientRect().top+scrollY-offset);
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.target.focus({preventScroll:true});
      window.scrollTo({top,behavior:reduced?'instant':'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort=null; this.observer?.disconnect();
      cancelAnimationFrame(this.raf); this.raf=0; clearTimeout(this.settle);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scroll-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-scroll-story')) {
  customElements.define('product-scroll-story', class extends HTMLElement {
    connectedCallback() {
      const autoCover = this.querySelector('.pss-auto-cover');
      if (autoCover) {
        const hideFailedCover = () => { autoCover.style.display = 'none'; };
        autoCover.addEventListener('error', hideFailedCover, {once:true});
        if (autoCover.complete && !autoCover.naturalWidth) hideFailedCover();
      }
      if (this.controller || this.dataset.mode !== 'sequence') return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motion.matches) return;
      try {
        const data = JSON.parse(this.querySelector('.pss-data').textContent);
        this.urls = (Array.isArray(data) ? data : data.split(/\s+/).filter(Boolean)).map(value => {
          const url = new URL(value, document.baseURI);
          if (url.protocol !== 'https:') throw new Error('HTTPS required');
          return url.href;
        });
      } catch (_) { return; }
      if (this.urls.length < 2 || this.urls.length > 240) return;
      this.controller = new AbortController();
      this.cache = new Map(); this.pending = new Set(); this.failed = new Set();
      this.target = 0; this.displayed = -1; this.tasks = 0;
      this.seen = new Set(); this.timers = new Set(); this.bytes = 0;
      this.budget = 64 * 1024 * 1024;
      this.keys = new Set(Array.from({length:Math.min(10,this.urls.length)}, (_,i) => Math.round(i*(this.urls.length-1)/(Math.min(10,this.urls.length)-1))));
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d');
      if (!this.context) { this.disconnectedCallback(); return; }
      this.track = this.querySelector('.pss-track');
      this.distance = Number(this.dataset.distance);
      this.width = innerWidth;
      this.measure = () => {
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--pss-offset')) || 0;
        this.stageHeight = Math.max(200, innerHeight - offset);
        this.style.setProperty('--pss-height', this.stageHeight + 'px');
        this.style.setProperty('--pss-distance', this.distance + 'px');
        this.displayed = -1;
      };
      this.schedule = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); });
      };
      this.measure();
      const options = { passive:true, signal:this.controller.signal };
      addEventListener('scroll', this.schedule, options);
      addEventListener('resize', () => {
        if (Math.abs(innerWidth - this.width) > 40) { this.width = innerWidth; this.measure(); }
        this.schedule();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.disconnectedCallback();
      }, {signal:this.controller.signal});
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near) this.schedule();
      }, {rootMargin:'600px'});
      this.observer.observe(this);
    }
    update() {
      if (!this.controller || !this.near) return;
      const top = this.track.getBoundingClientRect().top;
      const offset = parseFloat(getComputedStyle(this).getPropertyValue('--pss-offset')) || 0;
      this.target = Math.round(Math.max(0, Math.min(1, (offset - top) / this.distance)) * (this.urls.length - 1));
      const image = this.cache.get(this.target);
      if (image) this.draw(this.target, image);
      else if (this.cache.size) {
        const nearest = [...this.cache.keys()].reduce((a,b) => Math.abs(a-this.target) < Math.abs(b-this.target) ? a : b);
        this.draw(nearest, this.cache.get(nearest));
      }
      this.pump();
    }
    pump() {
      if (!this.near || !this.controller || document.hidden) return;
      const wanted = [this.target, ...this.keys];
      for (let step=1;step<=8;step++) wanted.push(this.target+step,this.target-step);
      if (this.urls.length <= 64) {
        for (let i=0;i<this.urls.length;i++) if (!this.seen.has(i)) wanted.push(i);
      }
      for (const index of wanted) {
        if (this.tasks >= 4) break;
        if (index < 0 || index >= this.urls.length || this.cache.has(index) || this.pending.has(index) || this.failed.has(index)) continue;
        this.tasks++; this.pending.add(index);
        const session = this.controller;
        const image = new Image();
        const finish = success => {
          clearTimeout(timer); this.timers.delete(timer); image.onload = null; image.onerror = null;
          if (this.controller !== session) return;
          this.tasks--; this.pending.delete(index);
          if (success) {
            const frame = document.createElement('canvas');
            frame.width = Math.min(image.naturalWidth, this.urls.length <= 64 ? 420 : 480);
            frame.height = Math.round(image.naturalHeight * frame.width / image.naturalWidth);
            const ctx = frame.getContext('2d');
            if (!ctx) { this.failed.add(index); this.schedule(); return; }
            ctx.drawImage(image,0,0,frame.width,frame.height);
            frame.naturalWidth=frame.width; frame.naturalHeight=frame.height;
            this.cache.set(index,frame); this.seen.add(index);
            this.bytes += frame.width*frame.height*4;
            while (this.bytes > this.budget && this.cache.size > this.keys.size+1) {
              const removable = [...this.cache.keys()].filter(i => !this.keys.has(i) && i !== this.target);
              if (!removable.length) break;
              const farthest = removable.sort((a,b) => Math.abs(b-this.target)-Math.abs(a-this.target))[0];
              const old = this.cache.get(farthest);
              this.bytes -= old.width*old.height*4;
              old.width=0; old.height=0; this.cache.delete(farthest);
            }
          } else this.failed.add(index);
          this.schedule();
        };
        const timer = setTimeout(() => finish(false), 12000);
        this.timers.add(timer);
        image.onload = () => finish(image.naturalWidth > 0);
        image.onerror = () => finish(false);
        image.src = this.urls[index];
      }
    }
    draw(index,image) {
      if (index === this.displayed) return;
      const rect = this.querySelector('.pss-stage').getBoundingClientRect();
      const ratio = Math.min(devicePixelRatio || 1, 2);
      const w = Math.round(rect.width * ratio), h = Math.round(rect.height * ratio);
      if (!w || !h) return;
      if (this.canvas.width !== w || this.canvas.height !== h) {
        this.canvas.width = w; this.canvas.height = h;
      }
      this.context.fillStyle=getComputedStyle(this).getPropertyValue('--pss-bg').trim() || '#111111';
      this.context.fillRect(0,0,w,h);
      const fit = getComputedStyle(this).getPropertyValue('--pss-fit').trim();
      const scale = (fit === 'cover' ? Math.max : Math.min)(w/image.naturalWidth,h/image.naturalHeight);
      const iw=image.naturalWidth*scale, ih=image.naturalHeight*scale;
      this.context.drawImage(image,(w-iw)/2,(h-ih)/2,iw,ih);
      this.displayed=index;
      if (!this.classList.contains('pss-active')) {
        this.classList.add('pss-ready','pss-active');
        this.displayed = -1;
        this.schedule();
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); cancelAnimationFrame(this.raf); this.raf = 0;
      this.timers?.forEach(clearTimeout); this.timers?.clear();
      this.cache?.forEach(frame => { frame.width=0; frame.height=0; });
      this.cache?.clear(); this.classList.remove('pss-active','pss-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
